// ============================================================
// FLYTRIP - Mock Data (frontend teaser). Will be replaced by
// TripJack API + MongoDB backend in Phase 2.
// ============================================================

const CDN = "https://flybtc.blr1.digitaloceanspaces.com/ncl";
export const ASSETS = {
  logo: `${CDN}/logos/az0tYLxPGoR4kJxE2bdXLEFsvHLbkZtm3OPcGIZG.png`,
  indiaFlag: `${CDN}/country_flags/in.svg`,
  banner: `${CDN}/banner/04RJVorV6nuSDoyYaxZDLlVSgSVK481v4mnlynS0.png?tr=w-1200`,
  airlineOffers: `${CDN}/banner/04RJVorV6nuSDoyYaxZDLlVSgSVK481v4mnlynS0.png`,
  faqImg: "https://images.unsplash.com/photo-1610074686292-32b818e06043?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxoYXBweSUyMHRyYXZlbGVyJTIwdXNpbmclMjBwaG9uZSUyMGFpcnBvcnQlMjBib29raW5nfGVufDB8fHx8MTc5MDYwNTc3MHww&ixlib=rb-4.1.0&q=85",
  customerService: "/desktop/theme1/assets/new/customer-service.png",
  bell: "/desktop/theme1/assets/new/bell.png",
  planeDashed: "/desktop/theme1/assets/new/plane-dashed-route.png",
};

export const airlineLogo = (code, w = 90) =>
  `${CDN}/airline_svg/${code}.svg?tr=w-${w}`;

export const CONTACT = {
  email: "support@flytrip.in",
  phone: "8796552993",
  phonePretty: "+91 87965 52993",
  address:
    "First Floor, H.no.- E66, Agarwal Dharamshala Gali, Opp - Sdr Girls Inter College, Rudrapur, U.s. Nagar, Kichha, Udham Singh Nagar, Uttarakhand, India, 263153",
  company: "Ajanabee Adventure Travel Pvt Ltd (FLYTRIP)",
};

// Worldwide airport list with valid IATA codes (compatible with TripJack search).
// TripJack uses standard IATA airport codes, so any valid code below works with live search.
export const AIRPORTS = [
  // ---------- INDIA (Domestic) ----------
  { code: "DEL", city: "Delhi", name: "Indira Gandhi International Airport", country: "India" },
  { code: "BOM", city: "Mumbai", name: "Chhatrapati Shivaji Maharaj International Airport", country: "India" },
  { code: "BLR", city: "Bangalore", name: "Kempegowda International Airport", country: "India" },
  { code: "HYD", city: "Hyderabad", name: "Rajiv Gandhi International Airport", country: "India" },
  { code: "MAA", city: "Chennai", name: "Chennai International Airport", country: "India" },
  { code: "CCU", city: "Kolkata", name: "Netaji Subhash Chandra Bose International Airport", country: "India" },
  { code: "GOI", city: "Goa (Dabolim)", name: "Goa International Airport (Dabolim)", country: "India" },
  { code: "GOX", city: "Goa (Mopa)", name: "Manohar International Airport", country: "India" },
  { code: "PNQ", city: "Pune", name: "Pune Airport", country: "India" },
  { code: "AMD", city: "Ahmedabad", name: "Sardar Vallabhbhai Patel International Airport", country: "India" },
  { code: "JAI", city: "Jaipur", name: "Jaipur International Airport", country: "India" },
  { code: "LKO", city: "Lucknow", name: "Chaudhary Charan Singh International Airport", country: "India" },
  { code: "PAT", city: "Patna", name: "Jay Prakash Narayan Airport", country: "India" },
  { code: "SXR", city: "Srinagar", name: "Sheikh ul-Alam International Airport", country: "India" },
  { code: "IXR", city: "Ranchi", name: "Birsa Munda Airport", country: "India" },
  { code: "DED", city: "Dehradun", name: "Jolly Grant Airport", country: "India" },
  { code: "COK", city: "Kochi", name: "Cochin International Airport", country: "India" },
  { code: "TRV", city: "Thiruvananthapuram", name: "Trivandrum International Airport", country: "India" },
  { code: "IXC", city: "Chandigarh", name: "Shaheed Bhagat Singh International Airport", country: "India" },
  { code: "IDR", city: "Indore", name: "Devi Ahilya Bai Holkar Airport", country: "India" },
  { code: "NAG", city: "Nagpur", name: "Dr. Babasaheb Ambedkar International Airport", country: "India" },
  { code: "VNS", city: "Varanasi", name: "Lal Bahadur Shastri International Airport", country: "India" },
  { code: "BBI", city: "Bhubaneswar", name: "Biju Patnaik International Airport", country: "India" },
  { code: "UDR", city: "Udaipur", name: "Maharana Pratap Airport", country: "India" },
  { code: "JDH", city: "Jodhpur", name: "Jodhpur Airport", country: "India" },
  { code: "BDQ", city: "Vadodara", name: "Vadodara Airport", country: "India" },
  { code: "RPR", city: "Raipur", name: "Swami Vivekananda Airport", country: "India" },
  { code: "STV", city: "Surat", name: "Surat International Airport", country: "India" },
  { code: "IXM", city: "Madurai", name: "Madurai Airport", country: "India" },
  { code: "VTZ", city: "Visakhapatnam", name: "Visakhapatnam International Airport", country: "India" },
  { code: "TRZ", city: "Tiruchirappalli", name: "Tiruchirappalli International Airport", country: "India" },
  { code: "ATQ", city: "Amritsar", name: "Sri Guru Ram Dass Jee International Airport", country: "India" },
  { code: "GAU", city: "Guwahati", name: "Lokpriya Gopinath Bordoloi International Airport", country: "India" },
  { code: "IMF", city: "Imphal", name: "Bir Tikendrajit International Airport", country: "India" },
  { code: "BHO", city: "Bhopal", name: "Raja Bhoj Airport", country: "India" },
  { code: "IXJ", city: "Jammu", name: "Jammu Airport", country: "India" },
  { code: "CJB", city: "Coimbatore", name: "Coimbatore International Airport", country: "India" },
  { code: "IXA", city: "Agartala", name: "Maharaja Bir Bikram Airport", country: "India" },
  { code: "IXB", city: "Bagdogra", name: "Bagdogra International Airport", country: "India" },
  { code: "GWL", city: "Gwalior", name: "Rajmata Vijayaraje Scindia Airport", country: "India" },
  // ---------- MIDDLE EAST ----------
  { code: "DXB", city: "Dubai", name: "Dubai International Airport", country: "United Arab Emirates" },
  { code: "AUH", city: "Abu Dhabi", name: "Zayed International Airport", country: "United Arab Emirates" },
  { code: "SHJ", city: "Sharjah", name: "Sharjah International Airport", country: "United Arab Emirates" },
  { code: "DOH", city: "Doha", name: "Hamad International Airport", country: "Qatar" },
  { code: "JED", city: "Jeddah", name: "King Abdulaziz International Airport", country: "Saudi Arabia" },
  { code: "RUH", city: "Riyadh", name: "King Khalid International Airport", country: "Saudi Arabia" },
  { code: "DMM", city: "Dammam", name: "King Fahd International Airport", country: "Saudi Arabia" },
  { code: "MCT", city: "Muscat", name: "Muscat International Airport", country: "Oman" },
  { code: "KWI", city: "Kuwait City", name: "Kuwait International Airport", country: "Kuwait" },
  { code: "BAH", city: "Bahrain", name: "Bahrain International Airport", country: "Bahrain" },
  { code: "TLV", city: "Tel Aviv", name: "Ben Gurion Airport", country: "Israel" },
  { code: "AMM", city: "Amman", name: "Queen Alia International Airport", country: "Jordan" },
  // ---------- SOUTH ASIA ----------
  { code: "KTM", city: "Kathmandu", name: "Tribhuvan International Airport", country: "Nepal" },
  { code: "CMB", city: "Colombo", name: "Bandaranaike International Airport", country: "Sri Lanka" },
  { code: "DAC", city: "Dhaka", name: "Hazrat Shahjalal International Airport", country: "Bangladesh" },
  { code: "MLE", city: "Male", name: "Velana International Airport", country: "Maldives" },
  { code: "KHI", city: "Karachi", name: "Jinnah International Airport", country: "Pakistan" },
  { code: "LHE", city: "Lahore", name: "Allama Iqbal International Airport", country: "Pakistan" },
  { code: "ISB", city: "Islamabad", name: "Islamabad International Airport", country: "Pakistan" },
  { code: "KBL", city: "Kabul", name: "Kabul International Airport", country: "Afghanistan" },
  // ---------- SOUTHEAST ASIA ----------
  { code: "SIN", city: "Singapore", name: "Singapore Changi Airport", country: "Singapore" },
  { code: "BKK", city: "Bangkok", name: "Suvarnabhumi Airport", country: "Thailand" },
  { code: "DMK", city: "Bangkok", name: "Don Mueang International Airport", country: "Thailand" },
  { code: "HKT", city: "Phuket", name: "Phuket International Airport", country: "Thailand" },
  { code: "CNX", city: "Chiang Mai", name: "Chiang Mai International Airport", country: "Thailand" },
  { code: "KUL", city: "Kuala Lumpur", name: "Kuala Lumpur International Airport", country: "Malaysia" },
  { code: "CGK", city: "Jakarta", name: "Soekarno-Hatta International Airport", country: "Indonesia" },
  { code: "DPS", city: "Bali (Denpasar)", name: "Ngurah Rai International Airport", country: "Indonesia" },
  { code: "SGN", city: "Ho Chi Minh City", name: "Tan Son Nhat International Airport", country: "Vietnam" },
  { code: "HAN", city: "Hanoi", name: "Noi Bai International Airport", country: "Vietnam" },
  { code: "MNL", city: "Manila", name: "Ninoy Aquino International Airport", country: "Philippines" },
  { code: "RGN", city: "Yangon", name: "Yangon International Airport", country: "Myanmar" },
  // ---------- EAST ASIA ----------
  { code: "HKG", city: "Hong Kong", name: "Hong Kong International Airport", country: "Hong Kong" },
  { code: "PEK", city: "Beijing", name: "Beijing Capital International Airport", country: "China" },
  { code: "PVG", city: "Shanghai", name: "Shanghai Pudong International Airport", country: "China" },
  { code: "CAN", city: "Guangzhou", name: "Guangzhou Baiyun International Airport", country: "China" },
  { code: "NRT", city: "Tokyo", name: "Narita International Airport", country: "Japan" },
  { code: "HND", city: "Tokyo", name: "Haneda Airport", country: "Japan" },
  { code: "KIX", city: "Osaka", name: "Kansai International Airport", country: "Japan" },
  { code: "ICN", city: "Seoul", name: "Incheon International Airport", country: "South Korea" },
  { code: "TPE", city: "Taipei", name: "Taiwan Taoyuan International Airport", country: "Taiwan" },
  // ---------- CENTRAL ASIA ----------
  { code: "TAS", city: "Tashkent", name: "Tashkent International Airport", country: "Uzbekistan" },
  { code: "ALA", city: "Almaty", name: "Almaty International Airport", country: "Kazakhstan" },
  { code: "GYD", city: "Baku", name: "Heydar Aliyev International Airport", country: "Azerbaijan" },
  { code: "TBS", city: "Tbilisi", name: "Tbilisi International Airport", country: "Georgia" },
  { code: "EVN", city: "Yerevan", name: "Zvartnots International Airport", country: "Armenia" },
  // ---------- EUROPE ----------
  { code: "LHR", city: "London", name: "Heathrow Airport", country: "United Kingdom" },
  { code: "LGW", city: "London", name: "Gatwick Airport", country: "United Kingdom" },
  { code: "STN", city: "London", name: "London Stansted Airport", country: "United Kingdom" },
  { code: "MAN", city: "Manchester", name: "Manchester Airport", country: "United Kingdom" },
  { code: "EDI", city: "Edinburgh", name: "Edinburgh Airport", country: "United Kingdom" },
  { code: "CDG", city: "Paris", name: "Charles de Gaulle Airport", country: "France" },
  { code: "ORY", city: "Paris", name: "Orly Airport", country: "France" },
  { code: "FRA", city: "Frankfurt", name: "Frankfurt Airport", country: "Germany" },
  { code: "MUC", city: "Munich", name: "Munich Airport", country: "Germany" },
  { code: "BER", city: "Berlin", name: "Berlin Brandenburg Airport", country: "Germany" },
  { code: "AMS", city: "Amsterdam", name: "Amsterdam Airport Schiphol", country: "Netherlands" },
  { code: "FCO", city: "Rome", name: "Leonardo da Vinci-Fiumicino Airport", country: "Italy" },
  { code: "MXP", city: "Milan", name: "Milan Malpensa Airport", country: "Italy" },
  { code: "MAD", city: "Madrid", name: "Adolfo Suarez Madrid-Barajas Airport", country: "Spain" },
  { code: "BCN", city: "Barcelona", name: "Josep Tarradellas Barcelona-El Prat Airport", country: "Spain" },
  { code: "ZRH", city: "Zurich", name: "Zurich Airport", country: "Switzerland" },
  { code: "GVA", city: "Geneva", name: "Geneva Airport", country: "Switzerland" },
  { code: "VIE", city: "Vienna", name: "Vienna International Airport", country: "Austria" },
  { code: "IST", city: "Istanbul", name: "Istanbul Airport", country: "Turkey" },
  { code: "SAW", city: "Istanbul", name: "Sabiha Gokcen International Airport", country: "Turkey" },
  { code: "ATH", city: "Athens", name: "Athens International Airport", country: "Greece" },
  { code: "DUB", city: "Dublin", name: "Dublin Airport", country: "Ireland" },
  { code: "BRU", city: "Brussels", name: "Brussels Airport", country: "Belgium" },
  { code: "CPH", city: "Copenhagen", name: "Copenhagen Airport", country: "Denmark" },
  { code: "ARN", city: "Stockholm", name: "Stockholm Arlanda Airport", country: "Sweden" },
  { code: "OSL", city: "Oslo", name: "Oslo Gardermoen Airport", country: "Norway" },
  { code: "HEL", city: "Helsinki", name: "Helsinki-Vantaa Airport", country: "Finland" },
  { code: "WAW", city: "Warsaw", name: "Warsaw Chopin Airport", country: "Poland" },
  { code: "LIS", city: "Lisbon", name: "Humberto Delgado Airport", country: "Portugal" },
  { code: "PRG", city: "Prague", name: "Vaclav Havel Airport Prague", country: "Czech Republic" },
  { code: "SVO", city: "Moscow", name: "Sheremetyevo International Airport", country: "Russia" },
  { code: "DME", city: "Moscow", name: "Moscow Domodedovo Airport", country: "Russia" },
  // ---------- NORTH AMERICA ----------
  { code: "JFK", city: "New York", name: "John F. Kennedy International Airport", country: "United States" },
  { code: "EWR", city: "Newark", name: "Newark Liberty International Airport", country: "United States" },
  { code: "LAX", city: "Los Angeles", name: "Los Angeles International Airport", country: "United States" },
  { code: "SFO", city: "San Francisco", name: "San Francisco International Airport", country: "United States" },
  { code: "ORD", city: "Chicago", name: "O'Hare International Airport", country: "United States" },
  { code: "MIA", city: "Miami", name: "Miami International Airport", country: "United States" },
  { code: "ATL", city: "Atlanta", name: "Hartsfield-Jackson Atlanta International Airport", country: "United States" },
  { code: "DFW", city: "Dallas", name: "Dallas/Fort Worth International Airport", country: "United States" },
  { code: "BOS", city: "Boston", name: "Logan International Airport", country: "United States" },
  { code: "IAH", city: "Houston", name: "George Bush Intercontinental Airport", country: "United States" },
  { code: "SEA", city: "Seattle", name: "Seattle-Tacoma International Airport", country: "United States" },
  { code: "IAD", city: "Washington DC", name: "Washington Dulles International Airport", country: "United States" },
  { code: "YYZ", city: "Toronto", name: "Toronto Pearson International Airport", country: "Canada" },
  { code: "YVR", city: "Vancouver", name: "Vancouver International Airport", country: "Canada" },
  { code: "YUL", city: "Montreal", name: "Montreal-Trudeau International Airport", country: "Canada" },
  { code: "YYC", city: "Calgary", name: "Calgary International Airport", country: "Canada" },
  { code: "YXX", city: "Abbotsford", name: "Abbotsford International Airport", country: "Canada" },
  { code: "MEX", city: "Mexico City", name: "Benito Juarez International Airport", country: "Mexico" },
  { code: "CUN", city: "Cancun", name: "Cancun International Airport", country: "Mexico" },
  // ---------- SOUTH AMERICA ----------
  { code: "GRU", city: "Sao Paulo", name: "Sao Paulo/Guarulhos International Airport", country: "Brazil" },
  { code: "GIG", city: "Rio de Janeiro", name: "Rio de Janeiro/Galeao International Airport", country: "Brazil" },
  { code: "EZE", city: "Buenos Aires", name: "Ministro Pistarini International Airport", country: "Argentina" },
  { code: "SCL", city: "Santiago", name: "Arturo Merino Benitez International Airport", country: "Chile" },
  { code: "LIM", city: "Lima", name: "Jorge Chavez International Airport", country: "Peru" },
  // ---------- AFRICA ----------
  { code: "CAI", city: "Cairo", name: "Cairo International Airport", country: "Egypt" },
  { code: "JNB", city: "Johannesburg", name: "O.R. Tambo International Airport", country: "South Africa" },
  { code: "CPT", city: "Cape Town", name: "Cape Town International Airport", country: "South Africa" },
  { code: "NBO", city: "Nairobi", name: "Jomo Kenyatta International Airport", country: "Kenya" },
  { code: "LOS", city: "Lagos", name: "Murtala Muhammed International Airport", country: "Nigeria" },
  { code: "ADD", city: "Addis Ababa", name: "Addis Ababa Bole International Airport", country: "Ethiopia" },
  { code: "CMN", city: "Casablanca", name: "Mohammed V International Airport", country: "Morocco" },
  { code: "MRU", city: "Mauritius", name: "Sir Seewoosagur Ramgoolam International Airport", country: "Mauritius" },
  // ---------- OCEANIA ----------
  { code: "SYD", city: "Sydney", name: "Sydney Kingsford Smith Airport", country: "Australia" },
  { code: "MEL", city: "Melbourne", name: "Melbourne Airport", country: "Australia" },
  { code: "BNE", city: "Brisbane", name: "Brisbane Airport", country: "Australia" },
  { code: "PER", city: "Perth", name: "Perth Airport", country: "Australia" },
  { code: "AKL", city: "Auckland", name: "Auckland Airport", country: "New Zealand" },
  { code: "NAN", city: "Nadi", name: "Nadi International Airport", country: "Fiji" },
];

// Search airports by code/city/name/country with relevance ranking
export const searchAirports = (query, limit = 60) => {
  const q = (query || "").trim().toLowerCase();
  if (!q) return AIRPORTS.slice(0, limit);
  const scored = AIRPORTS.map((a) => {
    const code = a.code.toLowerCase();
    const city = a.city.toLowerCase();
    const name = a.name.toLowerCase();
    const country = a.country.toLowerCase();
    let score = -1;
    if (code === q) score = 100;
    else if (code.startsWith(q)) score = 90;
    else if (city === q) score = 80;
    else if (city.startsWith(q)) score = 70;
    else if (city.includes(q)) score = 60;
    else if (name.includes(q)) score = 40;
    else if (country.includes(q)) score = 20;
    return { a, score };
  }).filter((x) => x.score >= 0);
  scored.sort((x, y) => y.score - x.score);
  return scored.slice(0, limit).map((x) => x.a);
};

export const SPECIAL_FARES = [
  {
    id: "regular",
    title: "Regular",
    sub: "Lowest Fares",
    info: null,
  },
  {
    id: "student",
    title: "Student",
    sub: "Extra Baggage",
    info: "Only students above 12 years of age are eligible for special fares and/or additional baggage allowances. Carrying valid student ID cards and student visas (where applicable) is mandatory, else the passenger may be denied boarding or asked to pay for extra baggage.",
  },
  {
    id: "senior",
    title: "Senior Citizen",
    sub: "Exclusive Discount",
    info: "Only senior citizens above the age of 60 years can avail this special fare. It is mandatory to produce proof of Date of Birth at the airport, without which prevailing fares will be charged.",
  },
];

export const WHATS_NEW = [
  "Flash Sales & Limited-Time Deals : Hurry! Flash Sale on Flights & Hotels - Discounts Up to 60%!",
  "Limited-Time Offer: Book Your Holiday at Best Prices!",
  "Last-Minute Deals on Weekend Getaways - Save Big Today!",
];

export const COUPON = {
  code: "TRAVO200",
  date: "31 Jan, 2025",
  title: "Flat 200 Off on Flights!!! Christmas and New Year Special Offer",
};

export const DEAL_TABS = [
  { id: "all", label: "All Offers" },
  { id: "flight", label: "Flight" },
  { id: "hotel", label: "Hotels" },
  { id: "bus", label: "Bus" },
  { id: "holiday", label: "Holidays" },
];

export const DEALS = [
  { id: 1, cat: "hotel", img: `${CDN}/offers/gwd93WvyxWwwX4TntrUvWNlwSsCQqQkQ0sywd2lN.jpg?tr=w-480`, title: "Get Best offers on Hotel Booking", desc: "Get Best offers on Hotel Booking" },
  { id: 2, cat: "bus", img: `${CDN}/offers/lJ0hiCCmlDIRY113w53mJzjOoIsfduvRAL2CvGcw.jpg?tr=w-480`, title: "Sandhu Travels", desc: "Avail up to 10% instant discount* on bus, cabs & trains." },
  { id: 3, cat: "hotel", img: `${CDN}/offers/QGt7nwOojveTmUAzJzr3bMfDs0mxjTgSZYMNsNj9.jpg?tr=w-480`, title: "100+ Radisson Hotels across 60+ cities", desc: "Choose from 100+ Radisson Hotels across 60+ cities in India and book delightful stays." },
  { id: 4, cat: "holiday", img: `${CDN}/offers/VyjTk3jTkAuBekYPyI2xhHisK67LCrwgTJ0rShlL.png?tr=w-480`, title: "Special Visa Services Deal - Flat 25% OFF", desc: "Hassle-Free Visa Application & Processing for Your Next Adventure!" },
  { id: 5, cat: "holiday", img: `${CDN}/offers/16gwzW2KqQlJW2L1b0WTWueZJAOz8ApFsWiYd8pk.png?tr=w-480`, title: "Visa Excellence - Explore the World", desc: "Seamless Global Visa Processing for Unforgettable Journeys." },
  { id: 6, cat: "bus", img: `${CDN}/offers/1vHjfY2OlTHgMpDJg2krtyiD35Jhr2agMUYLrRSV.png?tr=w-480`, title: "Rent a Car", desc: "Comfortable and trusted ride" },
  { id: 7, cat: "bus", img: `${CDN}/offers/PPQ11bEyaOY8OdEaRurIkxnc618PjdUKVqjykhWU.png?tr=w-480`, title: "20% OFF ON ALL CAB RIDES", desc: "Book your next ride with confidence and enjoy up to 20% OFF on every cab booking." },
  { id: 8, cat: "holiday", img: `${CDN}/offers/IU9nRyc0qAocwrJjVYXcSlSihslvb3DzFeKzlxWI.jpg?tr=w-480`, title: "Exclusive Travel Offers Live Now", desc: "Explore top destinations with unbeatable deals on flights, hotels & complete holiday packages." },
  { id: 9, cat: "holiday", img: `${CDN}/offers/7i1BL421e1qSVCX94fl5AodcV8Cwtk8dpm4908Qo.jpg?tr=w-480`, title: "Mega Travel Deals & Holiday Offers", desc: "Book amazing holiday packages with exciting discounts on hotels, sightseeing & more." },
  { id: 10, cat: "hotel", img: `${CDN}/offers/FRXl7pIC464P9jU3skCB8qzTQePtLTlHzKCOxdsR.jpg?tr=w-480`, title: "Last-Minute Hotel Deals", desc: "Get best hotel deals in last minutes" },
  { id: 11, cat: "flight", img: `${CDN}/offers/o3YDgu4YbMdSplQ6eaW5Af8eNKZvXG7AcOlRHL4v.jpg?tr=w-480`, title: "Flat up to INR 2000 instant discount", desc: "Customer gets flat up to INR 2000 instant discount on bookings.", code: "TEST00001KA" },
  { id: 12, cat: "flight", img: `${CDN}/offers/fipm3gWTO8J0sBCHQ3Mu3xr8L4LDM4fn1GwT3XTP.jpg?tr=w-480`, title: "Grab Up to Rs. 2000 OFF* on Domestic Flights", desc: "Customer gets flat up to INR 2000 instant discount on bookings." },
  { id: 13, cat: "flight", img: `${CDN}/offers/fqPytyFx04PEHBYIOpA7JAIY6C4naNuOx65sogRm.jpg?tr=w-480`, title: "Grab Up to Rs. 2000 OFF* on Domestic Flights", desc: "Customer gets flat up to INR 2000 instant discount on bookings." },
  { id: 14, cat: "holiday", img: `${CDN}/offers/q0VGQvqhKfn7wQhtZRiUflSMOywfsdT1VFA3Mi72.png?tr=w-480`, title: "Book Your Holiday Trip Get 12% off", desc: "Book Your Holiday Trip Get 12% off" },
];

export const WHY_CHOOSE_US = [
  { img: `${CDN}/whywithus/yf9qN5CdtlLmG2MYoJWIz48BsTvWQMxi27JN7myA.png?tr=w-100`, title: "EXCITING DEALS", desc: "Enjoy exciting deals on flights, hotels, buses, car rental, tour packages and more." },
  { img: `${CDN}/whywithus/VJAJLzTuNDItWzhzsrXKoYOSWwkBgnESWjqv5GL7.png?tr=w-100`, title: "Personalized Travel Planning", desc: "AI-Powered Itineraries Tailored Just for You - Explore the World, Your Way!" },
  { img: `${CDN}/whywithus/vthUSUho0rxVWpeVL48pS7wjzdReb7eCdBoP0Nh6.png?tr=w-100`, title: "Sustainable & Ethical Travel", desc: "Eco-Friendly Adventures - Travel Responsibly & Leave Only Footprints!" },
  { img: `${CDN}/whywithus/Em2FOf1seGJFU8DFm7Oa8WplcCyVYinZ5vQDtASn.png?tr=w-100`, title: "24/7 SUPPORT", desc: "Get assistance 24/7 on any kind of travel related query. We are happy to assist you." },
];

export const DESTINATIONS = [
  { city: "Delhi", price: 17000, img: `${CDN}/destination/R0oi623nYoTjFvp5uJJDhGYIjY3SopslzKRB8Cnd.jpg?tr=w-400` },
  { city: "Jaipur", price: 14000, img: `${CDN}/destination/HqyZk6T2xngouAPqTpNwXC1f7rIWTOVaEV3ilo80.jpg?tr=w-400` },
  { city: "Dubai", price: 32500, img: `${CDN}/destination/P55wQvHB6EeP8AxKPVV7nb5pUsWMYSFYTq5r40xe.jpg?tr=w-400` },
  { city: "Singapore", price: 48000, img: `${CDN}/destination/NZ4DPTds94qvnAymfJzsEAPHAYuqp1sdLlncFcnR.webp?tr=w-400` },
  { city: "Manali", price: 7500, img: `${CDN}/destination/JZlIbweAi1VSJwxpXT5OKKuhgC0ZWp2Ymi704zxe.jpg?tr=w-400` },
];

export const POPULAR_AIRLINES = [
  { code: "BA", name: "British Airways" },
  { code: "OS", name: "Austrian Airlines" },
  { code: "6E", name: "IndiGo" },
  { code: "GF", name: "Gulf Air" },
  { code: "AA", name: "American Airlines" },
  { code: "KC", name: "Air Astana" },
  { code: "DE", name: "Condor Airlines" },
  { code: "EK", name: "Emirates Airlines" },
  { code: "9I", name: "AllianceAir" },
  { code: "FZ", name: "FlyDubai" },
];

// Build a real flight-search URL from IATA codes (used by homepage route/deal cards,
// mirrors cheapticket.in "Search Flight" behaviour — searches the ACTUAL route).
export const flightSearchUrl = (fromCode, toCode) => {
  const f = AIRPORTS.find((a) => a.code === fromCode);
  const t = AIRPORTS.find((a) => a.code === toCode);
  const d = new Date(Date.now() + 864e5);
  const dep = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const params = new URLSearchParams({
    tripType: "one-way",
    from: fromCode,
    fromCity: f?.city || fromCode,
    to: toCode,
    toCity: t?.city || toCode,
    dep,
    ret: "",
    ADT: "1",
    CHD: "0",
    INF: "0",
    cabin: "Economy",
    fare: "regular",
  });
  return `/flight/search?${params.toString()}`;
};

export const AIRLINE_DEALS = [
  { code: "BA", name: "British Airways", from: "DXB", to: "STN", date: "10-10-2026", price: 43999 },
  { code: "EK", name: "Emirates Airlines", from: "SXR", to: "DXB", date: "10-10-2026", price: 15000 },
  { code: "6E", name: "IndiGo", from: "BOM", to: "BLR", date: "10-10-2026", price: 10000 },
  { code: "AI", name: "Air India", from: "DEL", to: "BOM", date: "10-10-2026", price: 12222 },
  { code: "SG", name: "SpiceJet", from: "GOI", to: "DEL", date: "10-10-2026", price: 4999 },
  { code: "AC", name: "Air Canada", from: "BOM", to: "WTC", date: "10-10-2026", price: 47900 },
];

export const DOMESTIC_ROUTES = [
  { code: "AI", name: "Air India", from: "DEL", to: "CCU", price: 11111 },
  { code: "G9", name: "Air Arabia", from: "DEL", to: "BOM", price: 2222 },
  { code: "SG", name: "SpiceJet", from: "BOM", to: "LKO", price: 12222 },
  { code: "6E", name: "IndiGo", from: "DEL", to: "GOI", price: 10111 },
  { code: "EK", name: "Emirates Airlines", from: "DEL", to: "DED", price: 4322 },
  { code: "AI", name: "Air India", from: "BLR", to: "PAT", price: 1222 },
  { code: "6E", name: "IndiGo", from: "DEL", to: "HYD", price: 3450 },
  { code: "UK", name: "Vistara", from: "BOM", to: "MAA", price: 5200 },
];

export const INTL_ROUTES = [
  { code: "9I", name: "Alliance Air", from: "CCU", to: "SIN", price: 23444 },
  { code: "EK", name: "Emirates Airlines", from: "DEL", to: "DXB", price: 25000 },
  { code: "QR", name: "Qatar Airways", from: "DEL", to: "KTM", price: 23444 },
  { code: "IX", name: "AI Express", from: "BOM", to: "YXX", price: 22345 },
  { code: "BA", name: "British Airways", from: "CIR", to: "JED", price: 23222 },
  { code: "EK", name: "Emirates Airlines", from: "DEL", to: "DXB", price: 3999 },
  { code: "TG", name: "Thai Airways Intl", from: "BOM", to: "BKK", price: 14444 },
  { code: "SQ", name: "Singapore Airlines", from: "DEL", to: "SIN", price: 18999 },
];

export const BLOGS = [
  {
    img: `${CDN}/blog/JZel69SqR4hgDvbc2HHhqXl2TwGgTaWWDCf2jesr.webp?tr=w-400`,
    title: "The Best Way to Find Cheap Flights from Newark to Mumbai",
    date: "12 Jun 2026", read: "4 min read",
    excerpt: "Smart timing, flexible dates and the right fare tools can cut hundreds off a Newark–Mumbai ticket. Here's how seasoned flyers do it.",
    body: [
      "Long-haul routes like Newark (EWR) to Mumbai (BOM) see huge price swings depending on when you book and fly. The single biggest lever is flexibility: shifting your departure by even two or three days can save you 20–30% on the fare.",
      "Use a fare calendar to compare a whole month at a glance and spot the cheapest dates instantly — mid-week departures (Tuesday and Wednesday) are almost always cheaper than weekends. Booking 6–10 weeks ahead usually hits the sweet spot for this route.",
      "Consider one-stop itineraries through Gulf hubs (Dubai, Doha, Abu Dhabi) — they're frequently cheaper than non-stops and come with generous baggage. Finally, always compare the branded fare options: a 'Value' fare with 15kg checked baggage often works out cheaper than a 'Saver' fare plus paid baggage.",
    ],
  },
  {
    img: `${CDN}/blog/EHC37VOfSJBRXUTPwkBAmh8nzByy0NepWfpPkNmk.jpg?tr=w-400`,
    title: "Visa Deals & Tips: Get Approved Faster",
    date: "05 Jun 2026", read: "3 min read",
    excerpt: "A clean application is an approved application. Here are the documents and habits that speed up your visa.",
    body: [
      "Most visa rejections come down to incomplete paperwork, not bad luck. Start with a passport valid for at least six months beyond your travel dates, and keep two blank pages free.",
      "Show clear financial capacity: recent bank statements, salary slips and confirmed return flight and hotel bookings reassure consulates you'll return home. Our team can provide dummy/confirmed itineraries for your application.",
      "Apply early — peak seasons (summer and December) have long queues. If a previous visa was rejected, address the exact stated reason head-on with extra documentation. Our visa assistance desk reviews your file before submission to catch issues in advance.",
    ],
  },
  {
    img: `${CDN}/blog/YLisIaJewWB4JpzRaJHj1jPAZP8kxKMHRkkmstbr.jpg?tr=w-400`,
    title: "Pack Smart & Light: Travel Packing Tips",
    date: "28 May 2026", read: "3 min read",
    excerpt: "Beat baggage fees and travel stress with a capsule packing method the pros swear by.",
    body: [
      "The golden rule: lay out everything you think you need, then pack half of it. A versatile capsule of neutral, mix-and-match clothing covers a week in a single cabin bag.",
      "Roll clothes instead of folding to save space and reduce wrinkles, and use packing cubes to stay organised. Wear your heaviest items (jacket, boots) on the plane to keep the bag light.",
      "Keep essentials — passport, medication, charger, a change of clothes — in your cabin bag, never checked. Carry a slim power bank and a universal adapter, and leave room for shopping on the way back.",
    ],
  },
  {
    img: `${CDN}/blog/yNdQLba2fJNKnJkbESVzLGqpPVEw5iXAqL5pvcaH.jpg?tr=w-400`,
    title: "Best Holiday Package Deals: Auckland & Beyond",
    date: "20 May 2026", read: "4 min read",
    excerpt: "From New Zealand's fjords to city adventures, curated packages take the planning stress off your plate.",
    body: [
      "Auckland is the perfect base for a New Zealand adventure — think harbour cruises, day trips to Waiheke Island, and easy access to the wider North Island. A well-built package bundles flights, hotels and transfers so you pay less and plan less.",
      "Shoulder seasons (spring and autumn) offer great weather with fewer crowds and lower prices. Look for packages that include free cancellation and flexible dates so you can lock in a deal without risk.",
      "Our curated holiday packages combine handpicked hotels with the best flight fares and add local experiences — all bookable in a few taps with our 24x7 support behind you.",
    ],
  },
  {
    img: `${CDN}/blog/31nJQrOKzFPXQRTL4XeECYA58B0YSGrjereeNYHM.jpg?tr=w-400`,
    title: "How to Grab the Best In-Flight Deals",
    date: "14 May 2026", read: "3 min read",
    excerpt: "Coupons, fare types and timing — a quick guide to squeezing maximum value from every ticket.",
    body: [
      "Airlines and travel platforms run frequent flash sales — subscribe to deal alerts and keep an eye on limited-time coupon codes at checkout (they can knock ₹300–₹750 off instantly).",
      "Choose the right fare family: if you'll carry bags or want free date changes, a slightly higher 'Flexi' fare can be cheaper than a base fare plus add-ons. Always read the baggage and cancellation terms.",
      "Book on weekdays, travel mid-week, and use the fare calendar to find the cheapest nearby date. Combine a flight + hotel in one trip to unlock automatic combo discounts.",
    ],
  },
];

export const TESTIMONIALS = [
  { img: `${CDN}/testimonial/xxsu3c0QFRVpqobldT85Qghc4jXqLLL3PPYZrtdX.jpg`, name: "Neha Jha", role: "Customer", text: "I had a smooth experience booking my flight to New York. The price was reasonable, and the confirmation email came through quickly. Just wish there were more filters for layover times!" },
  { img: `${CDN}/testimonial/lHMyk4Cn3wjkiRWHOI2cAMBLUpDdFO0SL3mwi9pW.png`, name: "Mahesh Kumar", role: "Agent", text: "Great offers on flight tickets! I got a discount on my Goa trip. Just wish there were more payment options, but overall, a great service." },
  { img: `${CDN}/testimonial/7suPFAvFOWuwkVpybMOXxPG4Yw7KjFxktCu9cKnk.jpg`, name: "Pooja Kumari", role: "Agent", text: "Best B2B fares and instant confirmation. The agent dashboard makes group bookings so easy for my clients." },
];

export const FAQS = [
  { q: "How do I book a trip on your website?", a: "To book a trip, simply choose your destination, select the travel package that suits your needs, and proceed to the booking page. Fill in the required details, such as travel dates, passenger information, and payment details. Once completed, you will receive a confirmation email with your booking details." },
  { q: "How do I cancel or change my reservation?", a: "To cancel or change a booking, please log into your account and visit the \"My Bookings\" section. Depending on the type of reservation, you may be able to make changes directly. If not, please contact our customer support team for assistance." },
  { q: "Are there any hidden fees when booking my trip?", a: "No, we strive to be transparent. All fees and charges, including taxes and additional service fees, will be shown during the booking process before you confirm your reservation." },
  { q: "Do you offer travel insurance?", a: "Yes, we offer a variety of travel insurance plans, which you can add during the booking process. These plans can cover trip cancellations, lost luggage, medical emergencies, and more." },
  { q: "What should I pack for a trip?", a: "Essentials: Passport, tickets, medications, toiletries, phone charger, and local currency. Clothing: Check the weather at your destination and pack accordingly. Accessories: Sunglasses, power bank, and adapters for electronics." },
  { q: "Can you help if my visa application is rejected?", a: "Yes. Our visa assistance team can help review the rejection reason and guide you on the available options, including reapplication and additional documentation where applicable." },
  { q: "Can I book a multi-destination trip?", a: "Yes, we offer multi-destination booking options. Simply select \"multi-city\" when searching for flights and choose your departure and arrival locations." },
  { q: "Is my personal information secure when booking through your website?", a: "Yes, we prioritize the security and privacy of your personal information. Our website uses industry-standard encryption and security measures to protect your data during the booking process." },
];

export const HOTELS = [
  { name: "Radisson Blu Plaza", city: "Delhi", price: 6500, rating: 4.5, img: `${CDN}/offers/QGt7nwOojveTmUAzJzr3bMfDs0mxjTgSZYMNsNj9.jpg?tr=w-480` },
  { name: "The Leela Palace", city: "Bangalore", price: 11200, rating: 4.8, img: `${CDN}/offers/gwd93WvyxWwwX4TntrUvWNlwSsCQqQkQ0sywd2lN.jpg?tr=w-480` },
  { name: "Taj Lands End", city: "Mumbai", price: 14800, rating: 4.7, img: `${CDN}/offers/UvgdpZyeWAxFFpNqzYHhJKy7IR8lOhlrNT4XPisP.jpg?tr=w-480` },
  { name: "ITC Rajputana", city: "Jaipur", price: 7900, rating: 4.4, img: `${CDN}/offers/OMaADLYVbyhHquwhRWmyGA0PdHDCxwJxPPJmRWdc.png?tr=w-480` },
];

export const PACKAGES = DESTINATIONS.map((d, i) => ({
  id: i + 1,
  city: d.city,
  price: d.price,
  img: d.img,
  nights: [3, 2, 4, 5, 3][i],
  days: [4, 3, 5, 6, 4][i],
  rating: [4.5, 4.3, 4.8, 4.7, 4.4][i],
}));

export const BUS_ROUTES = [
  { from: "Delhi", to: "Manali", price: 899, time: "12h 30m" },
  { from: "Mumbai", to: "Goa", price: 1099, time: "11h 15m" },
  { from: "Bangalore", to: "Chennai", price: 649, time: "6h 45m" },
  { from: "Jaipur", to: "Delhi", price: 499, time: "5h 30m" },
  { from: "Hyderabad", to: "Bangalore", price: 799, time: "8h 00m" },
  { from: "Delhi", to: "Jaipur", price: 449, time: "5h 15m" },
];

// -------------------- Mock Flight Generator --------------------
const FLIGHT_AIRLINES = [
  { code: "6E", name: "IndiGo" },
  { code: "AI", name: "Air India" },
  { code: "SG", name: "SpiceJet" },
  { code: "UK", name: "Vistara" },
  { code: "QP", name: "Akasa Air" },
  { code: "EK", name: "Emirates" },
];

const seedRand = (seed) => {
  let s = seed % 2147483647;
  if (s <= 0) s += 2147483646;
  return () => ((s = (s * 16807) % 2147483647) - 1) / 2147483646;
};

export const generateFlights = (fromCode, toCode, dateStr) => {
  const seed = (fromCode + toCode + (dateStr || ""))
    .split("")
    .reduce((a, c) => a + c.charCodeAt(0), 7);
  const rnd = seedRand(seed);
  const list = [];
  const count = 10 + Math.floor(rnd() * 5);
  for (let i = 0; i < count; i++) {
    const al = FLIGHT_AIRLINES[Math.floor(rnd() * FLIGHT_AIRLINES.length)];
    const depH = 5 + Math.floor(rnd() * 17);
    const depM = [0, 15, 30, 45][Math.floor(rnd() * 4)];
    const durMins = 75 + Math.floor(rnd() * 160);
    const arrTotal = depH * 60 + depM + durMins;
    const stops = rnd() > 0.55 ? 0 : 1;
    const base = 2800 + Math.floor(rnd() * 9000);
    const price = stops === 0 ? base + 1200 : base;
    const fmt = (t) =>
      `${String(Math.floor(t / 60) % 24).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
    list.push({
      id: `${al.code}-${1000 + Math.floor(rnd() * 9000)}-${i}`,
      airline: al.name,
      code: al.code,
      flightNo: `${al.code}-${1000 + Math.floor(rnd() * 9000)}`,
      depTime: fmt(depH * 60 + depM),
      arrTime: fmt(arrTotal),
      depHour: depH,
      duration: `${Math.floor(durMins / 60)}h ${String(durMins % 60).padStart(2, "0")}m`,
      durationMins: durMins,
      stops,
      via: stops === 1 ? ["DEL", "BOM", "HYD", "AMD"][Math.floor(rnd() * 4)] : null,
      price,
      refundable: rnd() > 0.5,
      seatsLeft: 2 + Math.floor(rnd() * 7),
    });
  }
  return list.sort((a, b) => a.price - b.price);
};

// -------------------- Mock Users (Phase 2 -> real auth) --------------------
export const MOCK_USERS = [
  { email: "user@flytrip.in", name: "Rahul Sharma", role: "customer", phone: "+91 98765 43210" },
  { email: "agent@flytrip.in", name: "Mahesh Kumar", role: "agent", agency: "Kumar Travels", wallet: 45230, phone: "+91 98111 22334" },
  { email: "admin@flytrip.in", name: "Admin", role: "admin", phone: "+91 87965 52993" },
];

export const formatINR = (n) =>
  "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
